import jaJP from './ja_JP'

export default {
  tagsView: {
    refresh: 'リフレッシュ',
    close: '閉じる',
    closeOthers: 'その他を閉じる',
    closeAll: 'すべて閉じる'
  },
  ...jaJP,
  ETD: 'ETD',
  ETA: 'ETA',
  i18nDemo: {
    message: 'これは中国語のヒントです',
    btnDesc: '中国語ボタン',
    messageBtn: 'クリックしてメッセージを見る'
  },
  baseInfo: {
    seaport: {
      tabPort: {
        tabName: 'port'
      },
      tabEdiPort: {
        tabName: 'ediPort',
        shipCompany: 'Ship Company',
        originPortCode: 'Origin Port Code',
        currentPortCode: 'Current Port Code',
        shipCompanyCheck: 'Please select a shipping company!',
        originPortCodeCheck: 'Please select a port!',
        currentPortCodeCheck: 'Please enter 5-digit port code!'
      },
      tabAmsPort: {
        tabName: 'amsPort',
        amsPortMaintain: 'Ams Port Maintain',
        usNo: 'US NO',
        englishName: 'English Name',
        unNo: 'UN NO',
        country: 'Country',
        remark: 'Remark',
        usNoCheck: 'Please Enter The Correct Us No',
        englishNameCheck: 'English Name Cannot Be Empty.',
        unNoCheck: 'Please Enter The Correct UN No.',
        countryCheck: 'Country Cannot Be Empty.'
      }
    },
    city: {
      code: 'Code',
      chineseName: 'Chinese Name',
      englishName: 'English Name',
      locationCode: 'City Code',
      country: 'Country',
      addBaseCity: 'Add Base City',
      codeCheck: 'Code cannot be empty!',
      englishNameCheck: 'Englsih Name cannot be empty!',
      countryCheck: 'Please select a country!',
      lon: 'Lon',
      lat: 'Lat'
    },
    overseaWarehouse: {
      warehouseCode: '倉庫番号',
      countryChineseName: 'Chinese Name',
      countryEnglishName: 'English Name',
      country: 'Country',
      province: '省',
      city: '市',
      zipCode: '郵便番号',
      address: 'Address',
      address1: 'Address 1',
      address2: 'Address 2',
      address3: 'Address 3',
      ifFba: 'Is Fba',
      entryRequirements: 'Entry Warehouse Requirements',
      warehouseAgeCalculationRules: 'Inventory Age Calculation Rules',
      warehouseAgeCalculationRulesEdit: 'Inventory Age Calculation Rules(Week)',
      btn: {
        newFbaWarehouse: 'Add FBA Warehouse',
        newOverseaWarehouse: 'Add Oversea Warehouse'
      },
      msg: {
        warehouseNoEmpty: 'Warehouse code cannot be empty',
        countryNoEmpty: 'Country cannot be empty',
        cityNoEmpty: 'City cannot be empty',
        zipCodeNoEmpty: 'Zip code cannot be empty',
        addressNoEmpty: 'Address cannot be empty',
        chineseNameNoEmpty: 'Chinese name cannot be empty',
        englishNameNoEmpty: 'English name cannot be empty',
        warehouseAgeCalculationRulesNoEmpty: 'Warehouse age calculation rules cannot be empty',
        unSelectFbaWarehouse: 'FBA warehouse not selected',
        canNotEditFbaWarehouse: 'Can Not Edit Amazon Warehouse',
        duplicateAddition: '{0} Already added, Cannot be added repeatedly',
        warehouseNoLen: 'The length of overseas warehouse code cannot exceed 16 digits'
      }
    },
    basicData: {
      continent: {
        code: 'Code',
        name: 'Name',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!'
      },
      region: {
        code: 'Code',
        name: 'Chinese Name',
        nameEnglish: 'English Name',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Chinese Name cannot be empty!'
      },
      mscService: {
        serviceCode: 'Service Code',
        serviceName: 'Service Name',
        serviceCodeCheck: 'Service Code cannot be empty!',
        serviceNameCheck: 'Service Name cannot be empty!'
      },
      network: {
        code: 'Network Code',
        name: 'Network Name',
        codeCheck: 'Network Code cannot be empty!',
        nameCheck: 'Network Name cannot be empty!'
      },
      currency: {
        serialNumber: 'Serial Number',
        code: 'Code',
        name: 'Chinese Name',
        localName: 'Local Name',
        interchangeCode: 'Interchange Code',
        isoCode: 'ISO Code',
        defaultFractionDigits: 'Currency Fraction Digits',
        symbol: 'Symbol',
        remarks: '備考',
        addBaseCurrency: 'Add Base Currency',
        serialNumberCheck: 'Serial Number cannot be empty!',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!',
        interchangeCodeCheck: 'Interchange Code cannot be empty!',
        isoCodeCheck: 'ISO Code cannot be empty!',
        defaultFractionDigitsCheck: 'Currency Fraction Digits cannot be empty!',
        carryRule: 'Currency carry rule',
        rounding: 'Rounding',
        truncation: 'Truncation'
      },
      eqType: {
        code: 'Code',
        name: 'Name',
        localName: 'Local Name',
        remarks: 'Remark',
        addBaseEQType: 'Add Base EQType',
        codeCheck: 'Code cannot be empty!'
      },
      packing: {
        serialNumber: 'Serial Number',
        code: 'Code',
        name: 'Name',
        englishName: 'English Name',
        chineseName: 'Chinese Name',
        interchangeCode: 'Interchange Code',
        isoCode: 'ISO Code',
        position: 'Position',
        ediCode: 'EDI Code',
        addBasePacking: 'Add Base Packing',
        serialNumberCheck: 'Serial Number cannot be empty!',
        codeCheck: 'Code cannot be empty!',
        interchangeCodeCheck: 'Interchange Code cannot be empty!',
        isoCodeCheck: 'ISO Code cannot be empty!',
        positionCheck: 'Position cannot be empty!',
        userDefinedField: 'User Defined Field'
      },
      orderFormType: {
        code: 'Code',
        name: 'Name',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!'
      },
      cargoType: {
        code: 'Code',
        chineseName: 'Chinese Name',
        englishName: 'English Name',
        sea: 'For Sea',
        air: 'For Air',
        fbaSea: 'For FBA Sea',
        fbaAir: 'For FBA Air',
        fbaRailway: 'For Fba Railway',
        codeCheck: 'Code cannot be empty!',
        chineseNameCheck: 'Chinese Name cannot be empty!'
      },
      incoTerm: {
        serialNumber: 'Serial Number',
        code: 'Code',
        name: 'Name',
        localName: 'Local Name',
        interchangeCode: 'Interchange Code',
        isoCode: 'ISO Code',
        remark: 'Remark',
        addBaseIncoTerm: 'Add Base Inco Term',
        serialNumberCheck: 'Serial Number cannot be empty!',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!',
        interchangeCodeCheck: 'Interchange Code cannot be empty!',
        isoCodeCheck: 'ISO Code cannot be empty!'
      },
      shippingTerm: {
        serialNumber: 'Serial Number',
        code: 'Code',
        name: 'Name',
        localName: 'Local Name',
        interchangeCode: 'Interchange Code',
        isoCode: 'ISO Code',
        remark: 'Remark',
        addBaseShippingTerm: 'Add Base Shipping Term',
        serialNumberCheck: 'Serial Number cannot be empty!',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!',
        interchangeCodeCheck: 'Interchange Code cannot be empty!',
        isoCodeCheck: 'ISO Code cannot be empty!',
        defaultContainerLoadType: 'Default ContainerLoadType',
        defaultShow: 'Default Show',
        operationTypeTip: '※ After configuration, the transportation terms can be displayed by default in the corresponding main document split transportation terms column of the marine export business corresponding to the consolidation type'
      },
      paymentTerm: {
        serialNumber: 'Serial Number',
        code: 'Code',
        name: 'Name',
        localName: 'Local Name',
        interchangeCode: 'Interchange Code',
        isoCode: 'ISO Code',
        remark: 'Remark',
        addBasePaymentTerm: 'Add Base Payment Term',
        serialNumberCheck: 'Serial Number cannot be empty!',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!',
        interchangeCodeCheck: 'Interchange Code cannot be empty!',
        isoCodeCheck: 'ISO Code cannot be empty!'
      },
      tradeTerm: {
        serialNumber: 'Serial Number',
        code: 'Code',
        name: 'Name',
        localName: 'Local Name',
        englishName: 'English Name',
        interchangeCode: 'Interchange Code',
        isoCode: 'ISO Code',
        remark: 'Remark',
        addBaseTradeTerm: 'Add Base Trade Term',
        serialNumberCheck: 'Serial Number cannot be empty!',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!',
        interchangeCodeCheck: 'Interchange Code cannot be empty!',
        isoCodeCheck: 'ISO Code cannot be empty!'
      },
      priceAirService: {
        code: 'Code',
        chineseName: 'Chinese Name',
        englishName: 'English Name',
        codeCheck: 'Code cannot be empty!',
        chineseNameCheck: 'Chinese Name cannot be empty!'
      },
      portGroup: {
        portCode: 'Port Code',
        groupCode: 'Group Code',
        portCodeCheck: 'Port Code cannot be empty!',
        groupCodeCheck: 'Group Code cannot be empty!'
      },
      otherChargeItem: {
        chargeItemCode: 'Code',
        chineseName: 'Chinese Name',
        measure: 'Measure',
        defaultApPrice: 'Default Ap Price',
        remark: 'Remark',
        chargeWeight: 'Charge Weight',
        wt: 'WT',
        job: 'Job',
        chargeItemCodeCheck: 'Code cannot be empty!',
        chineseNameCheck: 'Chinese Name cannot be empty!'
      },
      customerType: {
        typeId: 'Level',
        chineseName: 'Chinese Name',
        englishName: 'English Name',
        typeIdCheck: 'Level cannot be empty!',
        chineseNameCheck: 'Chinese Name cannot be empty!',
        englishNameCheck: 'English Name cannot be empty!'
      },
      appraisalCategory: {
        serialNumber: 'ばんごう',
        serialNumberCheck: '番号は必須です',
        code: 'コード',
        codeCheck: 'コードは空にできません',
        chineseName: 'ちゅうぶんめいしょう',
        englishName: 'えいぶんめいしょう',
        chineseNameCheck: 'ちゅうぶんめいしょうはひっすです!',
        englishNameCheck: 'えいぶんめいしょうはひっすです!'
      },
      blMode: {
        serialNumber: 'Serial Number',
        code: 'Code',
        name: 'Name',
        localName: 'Local Name',
        interchangeCode: 'Interchange Code',
        isoCode: 'ISO Code',
        blType: 'Bl Type',
        remark: 'Remark',
        addBaseBlMode: 'Add Bl Mode Term',
        serialNumberCheck: 'Serial Number cannot be empty!',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!',
        interchangeCodeCheck: 'Interchange Code cannot be empty!',
        isoCodeCheck: 'ISO Code cannot be empty!'
      },
      cutomJobType: {
        serialNumber: 'Serial Number',
        code: 'Code',
        name: 'Name',
        localName: 'Local Name',
        englishName: 'English Name',
        type: 'Type',
        remarks: 'Remark',
        containerLoadType: 'Container Load Type',
        se: 'SeaExport',
        si: 'SeaImport',
        ae: 'AirExport',
        ai: 'AirImport',
        re: 'RailwayExport',
        addBaseBlMode: 'Add Base Trade Term',
        serialNumberCheck: 'Serial Number cannot be empty!',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!',
        englishNameCheck: 'English Name cannot be empty!',
        typeCheck: 'Type cannot be empty!',
        interchangeCode: 'Interchange code',
        codeTips1: '*The code format is English and numbers, and the number of words is limited to 4 digits.',
        codeTips2: 'Code length exceeds the limit, please re-enter!',
        codeTips3: 'The code format is incorrect, please re-enter!',
        codeTips4: '*The code format is: English, numbers, and combinations, with a word limit of 10.'
      },
      chargeUnit: {
        codeCheck: 'Code cannot be empty!',
        chineseNameCheck: 'Chinese Name cannot be empty!',
        englishNameCheck: 'English Name cannot be empty!',
        chargeUnitAndUnitCheck: 'Check at least one display for billing unit and company, please select!',
        businessTypeCheck: 'Check at least one display for shipping or air transportation or FBA shipping or FBA air transportation or FBA railway transportation, please select!',
        seaFreightAndAirFreightCheck: 'Check at least one display for shipping and air transportation, please select!'
      },
      dangerousGoods: {
        codeCheck: 'Please fill in the UN number'
      },
      cargoInformation: {
        codeCheck: 'Code cannot be empty',
        chineseNameCheck: 'Chinese Name cannot be empty!',
        englishNameCheck: 'English Name cannot be empty!'
      },
      propulsionType: {
        codeCheck: 'Name cannot be empty!'
      },
      baseCustomsDeclarationType: {
        code: 'code',
        name: 'name',
        englishName: 'englishName',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Chinese Name cannot be empty!',
        englishNameCheck: 'English Name cannot be empty!',
        codeTooLong: 'Column 【Code】 Is Too Long',
        nameTooLong: 'Column 【Name】 Is Too Long',
        englishNameTooLong: 'Column 【EnglishName】 Is Too Long',
        addBaseCustomsDeclarationType: 'Add Base Customs Declaration Type',
        isPlatform: 'Is Platform',
        PlatformTip: 'The newly added data on the platform cannot be modified！'
      },
      gpExplainTitle: {
        codeCheck: 'Code cannot be empty',
        chineseNameCheck: 'Chinese Name cannot be empty!',
        englishNameCheck: 'English Name cannot be empty!'
      }
    },
    airport: {
      addBasePort: 'Add Base Port',
      serialNumber: 'Serial Number',
      code: 'Code',
      chineseName: 'Chinese Name',
      englishName: 'English Name',
      interchangeCode: 'Interchange Code',
      isoCode: 'Iso Code',
      countryCode: 'Country Code',
      region: 'Region',
      requirement: 'Port Requirement',
      whetherToAdd: 'Whether To Add',
      portAdd: 'Port Add',
      portEdit: 'Port Edit',
      cityName: 'City Name',
      cityCode: 'City Code',
      codeCheck: 'Please Fill In The Correct Port Code',
      interchangeCodeCheck: 'Exchange Code Cannot Be Empty',
      isoCodeCheck: 'ISO Code Cannot Be Empty',
      englishNameCheck: 'English Name Cannot Be Empty'
    },
    operation: {
      operationType: 'Operation Type',
      lobType: 'Lob Type',
      code: 'Code',
      lob: 'Lob',
      operationRequirementType: 'Operation Type',
      contentDescription: 'Code/Content description',
      operationMaintain: 'Operation Maintain',
      remark: 'Remark',
      enterContentDescription: 'Please enter a code or description'
    },
    customsCommodityCode: {
      code: 'Code',
      commodityName: 'Commodity Name',
      mfnRate: 'Mfn Rate',
      generalRate: 'General Rate',
      vat: 'Vat',
      legalUnit: 'LegalUnit',
      mscCommodity: 'MscCommodity',
      secondUnit: 'SecondUnit',
      superviseMode: 'SuperviseMode',
      customsCommodityCodeMaintain: 'Customs Commodity Code Maintain',
      countryCode: 'Country Code',
      countryCodeCheck: 'Country Code Cannot Be Empty. ',
      codeCheck: 'Code Cannot Be Empty. ',
      commodityNameCheck: 'Commodity Name Cannot Be Empty.'
    },
    usCommodityCode: {
      systemCode: 'System code',
      tradeName: 'Trade name',
      productDescription: 'Product description',
      descriptionCode: 'Description code',
      customsTariff: 'customs tariff',
      additionalTaxRate056: '056 additional tax rate',
      including499AdditionalTaxRate: 'Including 499 additional tax rate',
      including501AdditionalTaxRate: 'Including 501 additional tax rate',
      chinaAdditionalTaxRate: 'China additional tax rate',
      chinaSurtaxTariff: "China's surtax tariff",
      chinaSurtaxClause: 'China surtax clause',
      enable: 'Enable',
      disable: 'Disable',
      chinaHongKongSurtaxTariff: 'Hong Kong Surcharge Tax Regulations',
      remark: 'Remark'
    },
    country: {
      serialNumber: 'Serial Number',
      code: 'Code',
      englishName: 'English Name',
      chineseName: 'Chinese Name',
      continent: 'Continent',
      interchangeCode: 'Tnterchange Code',
      isoCode: 'Iso Code',
      countryMaintain: 'Country Maintain'
    },
    rateManagement: {
      copyRate: 'Copy Rate',
      originalCurrency: 'Original Currency',
      benchmarkCurrency: 'Benchmark Currency',
      rate: 'Rate',
      effectiveMonth: 'Effective Month',
      currentMonth: 'current Month',
      baseCuurency: 'Benchmark Currency',
      currency: 'Original Currency',
      month: 'Effective Month',
      rateMaintain: 'Rate Maintain',
      currencyCheck: 'Please Enter The Original Currency!',
      rateCheck: 'Please Enter The Exchange Rate!',
      rateIsTooLong: 'Rate Is Too Long, Please Modify!',
      repeatCheck: 'Duplicate Configuration Appears, Please Modify!',
      repeatCheck2: 'Duplicate Configuration Appears of {0} to {1}, Please Modify!',
      copyRateMaintain: 'Copy Rate',
      copyCurrentMonthCheck: 'Cannot Copy The Data Of The Current Month, Please Select Another Month!',
      copyRowDataCheck: 'No Data For This Month.',
      copyRateSuccess: 'Copy Rate Successfully.',
      notFoundRate: 'Cannot Find The Exchange Rate Of Currency {0}, Please Maintain The Relevant Exchange Rate In Time!',
      setRateCacheRange: '為替レートのキャッシュ期間を設定する',
      setRateCacheRangeNote: '為替レートキャッシュの月範囲を 18 ～ 36 か月に設定します',
      setRateCacheRangePrefix: 'キャッシュ月',
      setRateCacheRangeSuffix: '月'
    },
    // 合作伙伴
    partner: {
      companyName: '取引先名簿',
      companyType: '顧客種別',
      customerTypeId: '顧客ランク',
      remarks: '備考',
      approvedState: 'Approved State',
      volume: 'Volume',
      cmpIdx: '番号',
      shortName: '略称',
      cnShortName: 'コード',
      region: '国',
      area: '地域',
      chineseName: '中国語名',
      englishName: '英語名',
      contractStatus: 'Contract Status',
      branchId: '所属支社',
      approvedBy: '承認者',
      dateApproved: '承認日',
      createBy: '作成者',
      dateType: '作成日',
      controlSetting: 'Date type of credit control setting',
      creditDateType: 'Settlement Modes',
      blacklist: 'ブラックリスト',
      cargoSource: '集荷種別',
      receivableDeposit: '収支種別',
      accountingPeriod: '支払サイト',
      quota: '与信限度',
      creditQuota: '与信上限額',
      creditCurrency: '与信通貨',
      supplierDirector: 'サプライヤー責任者',
      dateCreated: '作成日',
      modifiedBy: '更新者',
      dateModified: '更新日',
      isActive: '有効状態',
      relateTenantUuid: 'Related Tenant Uuid',
      sales: ' 売上',
      freightVolume30: '30日（件）',
      freightVolume60: '60日（件）',
      freightVolume90: '90日（件）',
      freightVolumeGt30: '90日超（件）',
      // 基础信息
      basicInfo: {
        title: '基本情報',
        relatedBusinessType: '関連業務種別',
        scac: 'SCAC',
        province: 'Province',
        city: 'City',
        district: 'District'
      }
    },
    // 收发通地址
    mailingAddress: {
      office: 'office',
      lobType: 'lob Type',
      partner: 'partner',
      podName: 'pod Name',
      shipperCode: 'shipper Code',
      shipperInfo: 'shipper Info',
      consigneeCode: 'consignee Code',
      consigneeInfo: 'consignee Info',
      notifyCode: 'notify Code',
      notifyInfo: 'notify Info',
      shipperName: 'shipper Name',
      consigneeName: 'consignee Name',
      notifyName: 'notify Name',
      partner1: '顧客',
      pod1: 'pod',
      formatManifestInfo: 'Format Manifest Info',
      shipper: 'shipper',
      shipperEnterpriseCode: 'shipper Enterprise Code',
      shortCode: 'short Code',
      enterpriseCode: 'enterprise Code',
      shipperEnterpriseName: 'shipper Enterprise Name',
      shipperAddress: 'shipper Address',
      cityName: 'city Name',
      provinceCode: 'province Code',
      provinceName: 'province Name',
      zipCode: 'postal Code',
      countryCode: 'country Code',
      aeoEnterpriseCode: 'aeo Enterprise Code',
      syncFormatInfoToOrder: 'Synchronize FormatInfo To Order',
      consignee: 'consignee',
      instructBill: 'instruct Bill',
      consigneeEnterpriseCode: 'consignee Enterprise Code',
      consigneeEnterpriseName: 'consignee Enterprise Name',
      consigneeAddress: 'consignee Address',
      consigneeSpecificContactsName: 'consignee Specific Contacts Name',
      consigneeSpecificContacts: 'consignee Specific Contacts',
      notify: 'notify',
      notifyEnterpriseCode: 'notify Enterprise Code',
      notifyEnterpriseName: 'notify Enterprise Name',
      notifyAddress: 'notify Address',
      shipperPhoneNumber: 'shipper Phone Number',
      shipperEmail: 'shipper Email',
      shipperFax: 'shipper Fax',
      consigneePhoneNumber: 'consignee Phone Number',
      consigneeEmail: 'consignee Email',
      consigneeFax: 'consignee Fax',
      consigneeSpecificPhoneNumber: 'consignee Specific Phone',
      consigneeSpecificEmail: 'consignee Specific Email',
      consigneeSpecificFax: 'consignee Specific Fax',
      notifyPhoneNumber: 'notify Phone Number',
      notifyEmail: 'notify Email',
      notifyFax: 'notify Fax',
      addMailingAddress: 'Add sys Bill Address',
      editMailingAddress: 'Edit sys Bill Address',
      validLobMsg: 'Please select lob type.',
      validInstructBill: 'Consignee selected instructBill mode, then notifyEnterpriseCode and notifyContacts both required.',
      fbaWarehouseCode: 'Amazon倉庫コード',
      contactName: 'Contact name',
      province: 'Province',
      addr1: 'Address 1',
      addr2: 'Address 2',
      addr3: 'Address 3',
      eoriNo: 'Eori / enterprise number',
      taxNo: 'duty paragraph',
      ManifestFormatShipper: 'Manifest format shipper',
      TheManifestFormatConsignee: 'The manifest format consignee',
      ManifestFormatNotifier: 'Manifest Format Notifier'
    }
  },
  sysManage: { // 系统管理
    baseConfig: { // 基本配置
      triggerTypeManagement: { // 触发类型管理
        addTriggerType: 'AddTriggerType',
        editTriggerType: 'EditTriggerType',
        lookTriggerType: 'look Trigger Type',
        validFieldNameMsg: 'please input fieldName.',
        validFieldEnameMsg: 'please input fieldEname.',
        triggerType: 'triggerType',
        fieldCheckType: 'fieldCheckType',
        entityCode: 'entityCode',
        entityName: 'entityName',
        entityEname: 'entityEname',
        fieldCode: 'fieldCode',
        fieldName: 'fieldName',
        fieldEname: 'fieldEname',
        fieldCheckValue: 'fieldCheckValue',
        innerDateState: 'state comes from inner data',
        outerDateState: 'state comes from outer data',
        applySopNode: 'apply sop node',
        remark: '备注'
      },
      routeWareHouseConfiguration: { // 航线与仓库配置
        addRouteWareHouseMapping: 'AddRouteWareHouseMapping',
        editRouteWareHouseMapping: 'EditRouteWareHouseMapping',
        validRegionCodeMsg: 'please input regionCode.',
        validWarehouseMsg: 'please select warehouse.',
        regionCode: 'regionCode',
        warehouse: '倉庫',
        remark: 'remark'
      },
      singleOnlineSetting: { // 海运在线对单设置
        branchId: 'branchId',
        fieldCode: 'fieldCode',
        fieldName: 'fieldName',
        fclEdit: 'isFclEdit',
        lclEdit: 'isLclEdit'
      }
    }
  },
  sysMonitor: { // 系统监控
    sopSendLog: {
      orderNo: '通し番号',
      relationId: 'ビジネス番号',
      dateCreated: 'プッシュ時刻',
      type: 'タイプ',
      pushNode: 'プッシュノード',
      pushingChannel: 'プッシュチャネル',
      pushingResult: 'プッシュ結菓',
      receivingUser: '受信者',
      receivingTxt: '内容の説明',
      modifyDate: 'sop変更時間',
      file: 'ファイル'
    }
  },
  common: {
    defaultPlaceholder: 'キーワードを入力してください',
    BeginDate: '開始日',
    EndDate: '締め切り日',
    pagePer: 'バー/ページ',
    pleaseChoose: '選択してください',
    confirm: '確認する',
    reset: 'リセット',
    cancel: 'キャンセル',
    tips: {
      fuzzySearch: 'コード、名前などの曖昧なクエリを入力してください',
      fuzzyCodeSearch: 'コードあいまいクエリを入力してください',
      fuzzyModelSearch: '機種あいまい検索を入力してください',
      overseaWarehouseFuzzySearch: '海外倉庫コードのあいまい検索を入力してください',
      fuzzySearchForJudgment: '番号、判断原因のあいまい検索を入力してください',
      fuzzySearchForCustomEqType: 'Please enter the size and type of box for fuzzy query',
      hasOneAtleast: '少なくとも1つのレコードを選択してください',
      hasOneAtleastAudit: 'レビュー済みレコードを少なくとも1つ選択してください',
      saveSuccess: '保存に成功しました！',
      prompt: 'ヒント',
      cannotDeleteBranch: '料金プラン作成ブランチは削除できません！',
      systemPrompt: 'システムプロンプト',
      confirmDelete: 'このレコードの削除を確認しますか？',
      confirmCheck: '確認記録を確認しますか？',
      confirmCancelCheck: '記録のキャンセルを確認しますか？',
      confirm: '確認する',
      deleteSuccess: '削除に成功しました！',
      editSuccess: '編集成功！',
      deleteFail: '削除に失敗しました！',
      cancelDelete: '削除を取り消します！',
      yes: 'はい',
      no: 'いいえ',
      repeatedlyTip: '繰り返し追加',
      pleaseChoose: '選択してください',
      isAdded: '追加されたかどうか',
      resetSuccess: 'リセット成功！',
      warning: '警告',
      branchSame: '操作しているデータの支社は、現在の支社または1つ上の支社に属していません！'
    },
    btn: {
      refresh: 'リフレッシュ',
      query: 'データ検索',
      look: '表示',
      new: '新規作成',
      add: '追加する',
      edit: '編集',
      editAgain: '再編集',
      delete: '削除',
      exportExcel: 'Excelをエクスポート',
      downLoadTemplate: 'テンプレートのダウンロード',
      save: '保存',
      cancel: 'キャンセル',
      ok: 'OK',
      confirm: '確認する',
      back: '戻る',
      audit: '承認',
      reject: '拒否する',
      reset: 'リセット',
      close: '閉じる',
      yes: 'はい',
      no: 'いいえ',
      next: '次へ',
      confirmUpdate: '変更を確認します',
      enable: '有効',
      disable: '無効'
    },
    createBy: '作成者',
    dateCreated: '作成時刻',
    modifiedBy: '変更者',
    dateModified: '時刻の変更'
  },
  // 常量
  constant: {
    all: '全て',
    yes: 'はい',
    no: 'いいえ',
    greaterThan: 'より大きい',
    lessThan: 'より小さい',
    equal: '等しい',
    email: 'メール',
    note: 'メール',
    enterpriseWechat: '企業のウィーチャット',
    sop: {
      JOB_NO: '取引番号',
      CUSTOMER_ID: '委託先コード／名称',
      CUSTOMER_ID_CN: '委託先（中国語）',
      CUSTOMER_ID_US: '委託先（英語）',
      CARRIER_CN: '船会社（中国語）',
      CARRIER_US: '船会社（英語）',
      CARRIER_CODE: 'CARRIER',
      CARRIER_SHORT_NAME: 'CARRIER',
      DESTINATION_AGENT: '仕向代理店',
      DESIGNATION_AGENT: '指定フォワーダー',
      LOADING_PORT_CODE: '出発港',
      LOADING_PORT_CODE3: '出発港コード',
      DESTINATION_PORT_CODE: '仕向港',
      DESTINATION_PORT_CODE2: '仕向港コード',
      BARGE_POL: 'バージ出港',
      VESSEL: '船名',
      VOYAGE: 'クルージング',
      BRANCH_VESSEL: 'しせんはしけせんめい',
      BRANCH_VOYAGE: '支線はしけ航路',
      WAREHOUSE_NO: '入庫番号',
      SO_NO: 'S/O NO.',
      MBL: 'MB/L NO',
      HBL_NO: 'HB/L NO',
      ETD: 'ETD',
      ETA: 'ETA',
      ATD: 'ATD',
      ATA: 'ATA',
      CONSIGNEE_CODE: '荷受人',
      CUSTOMER_REF_NO: '参照番号',
      USER_DEFINED_FIELD1: 'カスタムフィールド1',
      USER_DEFINED_FIELD2: 'カスタムフィールド2',
      USER_DEFINED_FIELD3: 'カスタムフィールド3',
      USER_DEFINED_FIELD4: 'カスタムフィールド4',
      ESTIMATED_SHIPPING_DATE: '予定船期',
      CSR: 'カスタマーサービス担当',
      CSR_PHONE: 'カスタマーサービス電話',
      SINGLE_ADDRESS: 'シングルアドレス',
      CUTOFF_TIME: '締切日',
      EstimatedArrivalTime: '到着予定時刻',
      actualArrivalTime: '実際の到着時刻',
      PortDischargeTime: '船を降ろす時間',
      ActualLiftingDate: '実際のリフト時間',
      ActualReturnTime: '実際に空いている時間',
      MBLTransportationClause: 'マスタ運送条件',
      HBLTransportationClause: '個別運送条件',
      MasterBLFreightTerm: 'マスタ運送料条件',
      HBLFreightClause: '個別運賃条項',
      MORE_DOOR_QUANTITY: '多ゲートポイント数',
      ROUGH_WEIGHT: '多門点毛重',
      MORE_DOOR_VOLUME: 'マルチゲート点体積',
      PACKAGING_TYPE: 'パッケージタイプ',
      SHIPPER_CODE: 'HBL Shipper Code',
      BUSINESS_MODEL: 'ビジネスモデル',
      TICKET_RECEIPT: 'メインチケットのレシート',
      NO_LISTING: 'ドアポイントボックス番号リスト',
      ESTIMATED_DELIVERY_DATE: 'ドアポイントの配送予定日',
      UNLOADING_WAY: 'ドアポイントの荷下ろし方法',
      PO: 'PO',
      CNEE_CODE: 'HBL CNEE Code',
      ADDRESS: 'ゲートアドレス',
      BASIC_NUMBER: '基本タブ-件数',
      BASIC_ROUGH_WEIGHT: '基本タブ-総重量',
      BASIC_VOLUME: '基本タブ-体積',
      DELIVER_DATE: '集荷日',
      ARRIVE_STORAGE_DATE: 'ライブラリ到着日',
      TRANS_DATE: '交換日',
      CUSTOMER_REF_NO2: '顧客参照番号',
      LOADING_PORT_CODE2: '積港',
      CARRIER_ID: '航空会社',
      CARRIER_ID_CN: '航空会社（中国語）',
      CARRIER_ID_US: '航空会社（英語）',
      VOYAGE_FLIGHT: 'フライト',
      ETD2: '就航日',
      ETA2: '到着日',
      WAREHOUSE_NO2: '入庫番号',
      QUANTITY: '件数（入倉）',
      WEIGHT: '総重量（倉庫に入る）',
      VOLUME: '体積（倉庫に入る）',
      DOWNLOAD_URL: 'プレオーダーダウンロードリンク',
      MBL2: 'MAWB NO',
      HAWB: 'HAWB NO',
      DISCHARGING_PORT: '揚げ港',
      DISCHARGING_PORT2: '荷揚げ港コード',
      WAREHOUSE_DATA: '倉庫データ',
      STATUS_UPDATE_TIME: '状態変更時間',
      QUANTITY_CONTRACT: '依頼件数',
      WEIGHT_CONTRACT: '依頼総重量',
      CUBAGE_CONTRACT: '委託体積',
      TRUST_FROM_JOB: '委託関連番号',
      RELATED_JOB: '相互関係番号',
      BASIC_SHIPPER_CODE: '基本積荷コード',
      BASIC_CONSIGNEE_CODE: '基本荷受人コード',
      INCOTERMS: '取引条件',
      CHARGE_WEIGHT: '請求重量',
      PACKAGE: 'パッケージ',
      REMARK: 'コメント',
      POD: '納品先',
      LOADING_PORT_CODE4: '積港コード',

      MBLNO: 'マスタコード',
      CONTACT: '連絡先',
      AIR_LINE: 'エアライン',
      TRANSPORT_TYPE: '輸送タイプ',
      DEPARTURE_STATION: '始発駅',
      DEPARTURE_STATION_CODE: '始発駅コード',
      DESTINATION_STATION: '目的のステーション',
      DESTINATION_STATION_CODE: '宛先コード',
      TRANSIT_STATION: 'トランジットステーション',
      TRANSIT_STATION_CODE: '通過駅コード',
      PAYMENT_METHOD: '支払方法',
      TRACK_NO: '運送状番号',
      SHUTTLE: 'シャトルバス',
      TRAIN_NO: '列車番号',
      QUANTITY_ACTUAL: '実績件数',
      WEIGHT_ACTUAL: '実際の総重量',
      CUBAGE_ACTUAL: '実体積',
      CARGO_ENGLISH_NAME: '英語品名',
      SALES: '販売',
      SALES_EMAIL: '販売メールボックス',
      // 新增毛体重
      ACTUAL_PIECE: '件数（実績）',
      ACTUAL_WEIGHT: '総重量（実績）',
      ACTUAL_VOLUME: '体積（実際）',
      CUSTOMER_SERVICE: 'カスタマーサービス担当',
      DOCUMENT: '関連書類',
      ROUTE_MANAGER: '航路の責任者',
      OVERSEAS_CUSTOMER_SERVICE: '海外カスタマー',
      ROUTE_MANAGER_EMAIL: '航路担当者メールアドレス',
      INTEGRATION_TYPE: '統合タイプ',
      ROUTE_LEADER: 'ルートリーダー',
      ROUTE_LEADER_EMAIL: '路線担当者メールアドレス',
      OPERATE: '操作内容',
      PACKING: 'ほうそう',
      PACKING_CN: '包装（中国語）',
      PACKING_US: '包装（英語）',
      TYPE_OF_GOODS: '貨物分類コード',
      TYPE_OF_GOODS_CODE: '',
      MAIN_PAYMENT_LOCATION: 'マスター請求書支払サイト',
      MARK: 'うなずく',
      HS_NUMBER: 'HS番号',
      CUSTOM_POSITION_1: 'カスタムポジション1',
      CUSTOM_POSITION_2: 'カスタムポジション2',
      TRANSIT_PORT: '中継港',
      BOOKING_NUMBER: 'ブッキング番号',
      SHIPPING_NUMBER: '船会社約定番号',
      BARGES_REMARKS: '支線はしけ情報備考',
      MBL_SHIPPER: 'MB/L出荷者',
      MBL_CONSIGNEE: 'MB/L受取人',
      MBL_NOTIFIER: 'MB/L通知者'
    },
    nodeType: {
      lodingPort: '出発港',
      transferPort: '中継港',
      destinationPort: '到着港',
      warehousing: '倉庫',
      booking: '予約クラス',
      entrust: '依頼する',
      container: '箱を作る',
      distribution: '配送',
      supplement: '補足する'
    },
    // 推送渠道
    pushingChannel: {
      all: '全て',
      email: 'メール',
      msg: 'メッセージ'
    },
    // sop类型
    sopTypes: {
      all: '全て',
      sopSend: 'sopプッシュ',
      innerSend: '内部プッシュ'
    },
    // 推送结果
    pushResult: {
      all: '全て',
      success: '成功しました',
      fail: '失敗しました'
    },
    // 系统常量
    systemConstants: {
      SE: '海上輸出',
      SI: '海運輸入',
      AE: '空輸輸出',
      AI: '空輸輸入',
      RE: '鉄道の出口',
      RI: '航空輸入',
      RB: '鉄道業務',
      IE: '総合物流',
      FBASE: 'FBA海運',
      FBAAE: 'FBA空輸',
      FBARE: 'FBA鉄道'
    },
    // 提单流水号类型
    BillType: {
      MBL: 'メインシート',
      HBL: 'セクション'
    },
    // 进口业务常量
    importConstants: {
      FCL: '箱全体',
      LCL: '箱詰め',
      CON: 'コレクション',
      POJ: 'プロジェクト',
      PVE: '私物',
      ECL: '委託箱詰め',
      BULK: 'BULK',
      CONSOLE: '一主多分',
      DIRECT: 'ストレートシングル',
      BACK_TO_BACK: '一主一分'
    },
    // 空运出口常量
    airExportConstants: {
      CONSOLE: '一主多分',
      DIRECT: 'ストレートシングル',
      BACK_TO_BACK: '一主一分'
    },
    // 海运出口常量
    seaExportConstants: {
      CONTRACT_STATE_NO: '未契約',
      CONTRACT_STATE_OUT_OF_DATE: '契約の失効',
      CONTRACT_STATE_SIGNED: '契約済み'
    },
    templateRuleName: {
      CUSTOMER_CN_NAME: '顧客の氏名',
      CUSTOMER_SHORT_NAME: '顧客の短縮名',
      SETTLEMENT_CN_NAME: '決済対象の氏名',
      SETTLEMENT_SHORT_NAME: '決算対象の略称',
      BOOKING_AGENT_CN_NAME: '予約エージェント中国語',
      BOOKING_AGENT_SHORT_NAME: '予約エージェントの略称',
      LOB_NO: '取引番号',
      MBL_NO: 'MBL NO',
      HBL_NO: 'HBL NO',
      REF_NO: '通関番号',
      BILL_NO: '請求書番号',
      BILL_PAYMENT_NO: '支払番号',
      WAREHOUSE_NO: '倉庫に入る番号',
      PONO: 'プロジェクト番号',
      CUSTOMER_REF_NO: '参照番号',
      PLATE_NUMBER_DOOR: 'License plate number (current door point)',
      PLATE_NUMBER_DEST: 'License plate number (current destination)',
      CARRIER_CN_NAME: '運送会社の中国語名',
      CARRIER_SHORT_NAME: '運送会社略称',
      ETD: '出航予定日',
      DESTINATION_PORT_CODE: '行き先',
      DESTINATION_PORT_CODE_CODE: '宛先ポートコード'
    },
    genDocCondition: {
      FormalHbl: '分割伝票の形式'
    },
    buttonName: {
      FormalHbl: '分割伝票の形式'
    }
  },
  // 枚举参数
  parameter: {
    // 集装箱装载类型
    containerLoadType: {
      FCL: '箱全体',
      LCL: '箱詰め',
      BB: 'おまかせ箱詰め',
      BC: 'Buyer Console',
      BULK: 'ばら雑貨',
      SPA: '特殊ボックス'
    },
    // 合作伙伴服务项目
    partnerServiceItem: {
      ALL: '全て',
      CUSTOMER: '顧客',
      BOOKING_AGENT: '予約代理店',
      OVERSEA_AGENT: '宛先ポートエージェント',
      DESIGNATION_AGENT: '指定フォワーダー',
      LOCAL: '現地代理',
      SETTLEMENT_AGENT: '支払代行者',
      SEA_CMP: '船会社',
      AIR_CMP: '航空会社',
      SEA_CMP_AGENT: '船社代理',
      CUSTOMS_BROKER: '通関業者名／通関担当者',
      TRUCK_CMP: 'トラック会社',
      WAREHOUSE: '倉庫',
      GLOBAL: 'グループ会社',
      SHIPPER: '荷送人',
      CONSIGNEE: '荷受人',
      NOTIFY: '通知人',
      PORT_AGENT: '港湾代理',
      FORWARDING_AGENT: '出荷エージェント',
      LOADINGPLACE_COMPANY: '出荷元会社',
      SIGNBILLPLACE_COMPANY: 'サイン先会社',
      DISCHARGPORT_COMPANY: '荷揚げ港会社',
      DESTINATIONPORT_COMPANY: '仕向会社',
      OTHER: 'その他'
    },
    // 角色类型
    roleType: {
      SALES_TYPE: '販売',
      CSR_TYPE: '顧客サービス',
      DOC_TYPE: '関連書類',
      OVERSEAOP_TYPE: '海外顧客サービス',
      SALES_OF_GOODS: 'まとめ売り'
    }
  },
  advanceSearchForm: { // 高级查询组件
    ...jaJP,
    advSearchBtn: '高度なクエリ',
    quickSearch: 'クイック検索',
    more: 'より多くの条件',
    Equal: '等しい',
    Greater: 'より大きい',
    Less: 'より小さい',
    Unequal: '等しくない',
    Like: '含む',
    Not_Like: '含まれません',
    In: '含む',
    Range: '範囲',
    Batch: 'バッチ',
    BatchExclude: '一括除外',
    Regexp: '正規表現',
    Not_In: '含まれません',
    Is_Not_Null: '空ではない',
    Is_Null: '空です',
    Is_It_Empty: '空かどうか',
    Date_Item: 'ショートカットアイテム',
    customer: {
      level: '客商レベル',
      chineseName: '氏名',
      status: '顧客と仕入先の処理状況'
    },
    bookingNew: { // 海运订舱极速版
      destinationCountry: '目的地の国',
      hblCheckingStatus: 'HBL照合処理状況',
      hblBlType: 'HBL請求方式',
      hblBillOfLadingNumber: 'HBL請求書通し番号',
      hblReleasingStatus: 'HBLリリース状態',
      hblBlType2: 'HBL船荷証券タイプ',
      mblCheckingStatus: 'MBLログの状態',
      mblBlType: 'MBL荷受方式',
      mblBillOfLadingNumber: 'MBL荷受伝票番号',
      overseaCustomerService: '海外顧客サービス',
      customerLevel: ' 顧客ランク',
      isSignContract: '契約するかどうか',
      userDefinedField1: 'カスタムフィールド1',
      userDefinedField2: 'カスタムフィールド2',
      userDefinedField3: 'カスタムフィールド3',
      opOffice: 'オペレーション支社',
      salesOffice: '販売支社',
      bookingAgentIsNull: '予約エージェントが空です'
    },
    shortcut: 'ショートカットオプション',
    daterange: '範囲',
    alt: 'より小さい',
    gt: 'より大きい',
    eq: '等しい',
    notEq: '等しくない',
    like: '含む',
    draft: '下書き',
    commit: 'コミット',
    check: '監査',
    createDate: '作成日',
    nowWeek: '今週',
    preWeek: '先週',
    nextWeek: '来週',
    nowMonth: '今月',
    preMonth: '先月',
    nextMonth: '来月',
    doubleClickToSelect: 'テキストボックスをダブルクリックしてノード状態クエリを選択',
    fitAll: '以下をすべて満たす',
    fitAny: '次のいずれかを満たす'
  },
  route: {
    dashboard: 'トップページ',
    baseInfo: '基礎資料',
    airport: '空港',
    airlineCode: '航空会社コード',
    seaport: '海港',
    operationRequirementDescribe: '操作要求の説明',
    city: '都市',
    basicData: '基礎データ',
    customsCommodityCode: '税関商品コード',
    usCommodityCode: '米国商品コード',
    country: '国',
    rateManagement: '為替レート管理',
    chargeService: '課金アイテム',
    costPlan: '費用プラン',
    guarantee: '保証書です',
    payService: '有料アイテム',
    partner: 'お客様名簿',
    mailingAddress: '送受信アドレス',
    seaPortRequirement: 'ポート要求（海港）',
    airPortRequirement: 'ポート要求（空港）',
    partnerInformationImport: 'パートナー情報のインポート',
    seaExport: '海上輸出',
    bookingNew: '海運訂船室極速版',
    ProjectManage: 'プロジェクト管理',
    project: 'プロジェクト',
    seaImport: '海運輸入',
    airExportBooking: '空輸予約クラス',
    airImportBooking: '空輸操作',
    railwayExport: '鉄道の出口',
    seaImportBooking: '海運オペレーション',
    integratedJob: 'Integrated logistics',
    remoteBooking: 'Remote booking',
    prediction: 'prediction',
    preBooking: 'Pre booking',
    preOrder: 'Order Prequalification'
  },
  navbar: {
    logOut: 'ログアウト',
    dashboard: 'トップページ',
    github: 'プロジェクトのアドレス',
    theme: '肌を変える',
    size: 'レイアウトサイズ'
  },
  login: {
    title: 'システムログイン',
    logIn: 'ログイン',
    username: 'アカウント',
    password: 'パスワード',
    any: 'any'
  },
  act: {
    billing: {
      pleaseSelectBilling: '請求書を選択してください！',
      hasConfirmed: '【{0}】請求書が確認されました！',
      hasReviewed: '【{0}】請求書が検討されました！',
      hasBillingGroup: '【{0}】請求書が作成されました！',
      hasInvoice: '【{0}】請求書が請求されました！',
      hasWriteOff: '【{0}】請求書が消し込まれました！',
      confirmDelete: 'この{0}の請求書を削除してよろしいですか？',
      noConfirmBill: '確認できる請求書がありません！',
      noRecheckBill: '検討できる請求書がありません！',
      noCancelRecheckBill: 'キャンセル可能な請求書がありません！',
      batchConfirmBill: 'この{0}の請求書を一括確認しますか？',
      batchRecheckBill: 'この{0}個の請求書を一括して検討しますか？',
      noCancelConfirmBill: 'キャンセル可能な請求書がありません！',
      confirmCancelBill: 'この{0}の請求書の確認をキャンセルしますか？',
      cancelRecheckBill: 'この{0}の請求書の検討をキャンセルしますか？',
      sameSettlementAgent: '請求書の決済エージェントは同じでなければなりません！',
      hasBillingGroupNo: '請求書番号が作成されました',
      noBillToBillingGroup: '請求書がありません',
      confirmSuccess: '成功の確認！',
      recheckSuccess: 'チェックに成功しました！',
      cancelConfirmSuccess: 'キャンセルの確認に成功しました',
      cancelRecheckSuccess: 'キャンセルに成功しました！',
      reconciliationAmountNotSupport: '入力した決済金額が不正です！',
      overseaHasPushed: '【{0}】請求書はすでに送信済みのため、削除できません！',
      advDeleteConfirmTitle: '代理収納および前払いの請求書は既にKingdeeに送信済みです。削除する前に、Kingdee上で対応する伝票が削除されていることを確認してください！'
    },
    billingGroup: {
      hasConfirmed: '【{0}】請求書が確認されました！',
      hasReviewed: '【{0}】請求書をチェックしました!',
      confirmDelete: 'この{0}の請求書を削除してもよろしいですか？',
      billingNotNull: '請求書は空にできません！',
      canNotRemoveAllBills: 'すべての請求書を削除できません！',
      settlementAgentNotNull: '請求書【{0}】の決済エージェントは空にできません！',
      settlementAgentAndAccountCanNotSame: '請求書【{0}】の決済エージェントが取引明細書の決済対象と一緻しません。この請求書を削除して保存してください！',
      validateAp: '収支タイプが売掛金の場合、売掛金の合計金額は買掛金の合計金額より小さくすることはできません！',
      validateAr: '収支タイプが買掛金の場合、買掛金請求書の合計金額は売掛金請求書の合計金額より小さくすることはできません！',
      selectedBillingGroup: '取引明細書を選択してください！',
      batchConfirmBillGroup: 'この{0}の請求書を一括確認しますか？',
      batchConfirmBill: '請求書の処理状況は確認済みに更新されましたか？',
      noRecheckBillGroup: '照合する請求書がありません！',
      batchRecheckBillGroup: 'この{0}件の請求書を再チェックすることは確かですか?',
      batchCancelRecheckBillGroup: 'この{0}つの請求書の照合を取り消すことを確定しますか?',
      noCancelRecheckBillGroup: '照合を取り消す請求書はありません!',
      noCancelConfirmBillGroup: '請求書はチェック済みで、キャンセル確認はできません!'
    }
  },
  grid: {
    resetSort: '並べ替えのリセット',
    restColumns: '列をリセットする',
    autoSizeColumns: 'すべての列を自動調整',
    pinLeftAll: '左側のすべての列をロックします',
    subtotal: '小計',
    groupedSubtotal: '項目別小計',
    summaryMode: '統計集計モード',
    count: 'カウント',
    sum: '合計'
  }
}
// agGrid表格
export const i18n_ag_grid = {
  // Set Filter
  selectAll: 'すべて選択します',
  selectAllSearchResults: '（すべての検索結菓を選択）',
  searchOoo: '検索...',
  blanks: '空白',
  noMatches: '一緻する結菓がありません',

  // Number Filter & Text Filter
  filterOoo: 'フィルタ...',
  equals: '等しい',
  notEqual: '等しくない',
  empty: '選択してください',

  // Number Filter
  lessThan: 'より小さい',
  greaterThan: 'より大きい',
  lessThanOrEqual: 'より小さいか等しい',
  greaterThanOrEqual: '以上',
  inRange: '範囲',
  inRangeStart: 'から',
  inRangeEnd: 'から',

  // Text Filter
  contains: '含む',
  notContains: '含まない',
  startsWith: 'スタートから',
  endsWith: '終わり',

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',

  // Filter Conditions
  andCondition: 'と',
  orCondition: 'または',

  // Filter Buttons
  applyFilter: 'フィルタを適用...',
  resetFilter: 'リセット',
  clearFilter: 'クリア',
  cancelFilter: 'キャンセル',

  // Filter Titles
  textFilter: 'テキストフィルタ',
  numberFilter: '数値フィルタ',
  dateFilter: '日付フィルタ',
  setFilter: 'コレクションフィルタ',

  // Side Bar
  columns: '列の設定',
  filters: 'フィルタ',

  // columns tool panel
  pivotMode: 'ピボットモード',
  groups: 'データグループ',
  rowGroupColumnsEmptyMessage: '列名をここにドラッグすると、データをグループ化できます(現在のページです)',
  values: '値',
  valueColumnsEmptyMessage: '値列が空のメッセージ',
  pivots: 'ピボット',
  pivotColumnsEmptyMessage: 'ピボットカラム空メッセージ',

  // Header of the Default Group Column
  group: 'データのグループ化',

  // Other
  loadingOoo: 'ロード...',
  noRowsToShow: '検索結果なし',
  enabled: 'アクティブ化',

  // Menu
  pinColumn: '列をロックする',
  pinLeft: '左側をロックする',
  pinRight: '右側をロックする',
  noPin: 'ロックしない<>',
  valueAggregation: '値の集計',
  autosizeThiscolumn: '列の自動調整',
  autosizeAllColumns: 'すべての列を自動調整',
  groupBy: 'グループ化',
  ungroupBy: 'グループ化しない',
  resetColumns: 'リセット',
  expandAll: '展開します',
  collapseAll: '収縮',
  copy: 'コピー',
  ctrlC: 'ctrl + C',
  copyWithHeaders: 'コピーにはヘッダーが含まれます',
  paste: '貼り付け',
  ctrlV: 'ctrl + V',
  export: 'エクスポート',
  csvExport: 'CSV ',
  excelExport: 'Excel ',

  // Enterprise Menu Aggregation and Status Bar
  sum: 'と',
  min: '最小',
  max: '最大',
  none: 'ない',
  count: 'カウント',
  average: '平均値',
  filteredRows: 'フィルタ済み',
  selectedRows: '選択されています',
  totalRows: '合計行数',
  totalAndFilteredRows: '行数',
  more: 'もっと',
  to: '-',
  of: 'から',
  page: 'ページ',
  nextPage: '次ページ',
  lastPage: '最後のページ',
  firstPage: '最初のページ',
  previousPage: '前のページ',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'パースビューとパースモード',
  pivotChart: 'パースビュー',
  chartRange: 'グラフの範囲',

  columnChart: '棒グラフ',
  groupedColumn: 'グループ化されました',
  stackedColumn: '積み上げられました',
  normalizedColumn: '100%積重ねました',

  barChart: '棒グラフ',
  groupedBar: 'グループ化されました',
  stackedBar: '積み上げられました',
  normalizedBar: '100%積重ねました',

  pieChart: '円グラフ',
  pie: '餅',
  doughnut: '図環図',

  line: 'Line',

  xyChart: 'XY（散布図）',
  scatter: '散点',
  bubble: 'バブル',

  areaChart: '麺グラフ',
  area: '麺積',
  stackedArea: '積み上げられました',
  normalizedArea: '100%堆積済み',

  histogramChart: 'ヒストグラム',

  // Charts
  pivotChartTitle: 'データパースペクティブ',
  rangeChartTitle: '範囲図',
  settings: '設定',
  data: 'データ',
  format: '書式',
  categories: 'カテゴリ',
  defaultCategory: '（なし）',
  series: 'シリーズ',
  xyValues: 'XY値',
  paired: 'ペアパターン',
  axis: '軸',
  navigator: 'ナビゲーター',
  color: 'カラー',
  thickness: '厚さ',
  xType: 'Xタイプ',
  automatic: '自動',
  category: 'カテゴリ',
  number: '数字',
  time: '時間',
  xRotation: 'X回転',
  yRotation: 'Y回転',
  ticks: '目盛り',
  width: '幅',
  height: '高さ',
  length: '長さ',
  padding: 'パディング',
  spacing: '間隔',
  chart: 'アイコン',
  title: 'タイトル',
  titlePlaceholder: 'グラフのタイトル-ダブルクリックで編集可',
  background: '背景',
  font: 'フォント',
  top: 'トップ',
  right: '右',
  bottom: '底の部分',
  left: '左',
  labels: 'ラベル',
  size: 'サイズ',
  minSize: '最小サイズ',
  maxSize: '最大サイズ',
  legend: '説明',
  position: '位置',
  markerSize: 'マークサイズ',
  markerStroke: 'マーカーストローク',
  markerPadding: 'マーカーの塗り',
  itemSpacing: 'フィールド間隔',
  itemPaddingX: 'フィールドフィルX',
  itemPaddingY: 'フィールドフィルY',
  playoutHorizontalSpacing: '水平間隔',
  layoutVerticalSpacing: '垂直間隔',
  strokeWidth: 'ストロークの幅',
  offset: 'オフセット',
  offsets: 'オフセット',
  tooltips: 'ヒント',
  callout: 'マークアップ',
  markers: 'マーキング',
  shadow: '影',
  blur: 'ぼやける',
  xOffset: 'Xオフセット',
  yOffset: 'Yオフセット',
  lineWidth: '線幅',
  normal: '正常',
  bold: '太字',
  italic: 'イタリック体',
  boldItalic: '太字斜体',
  predefined: '事前定義済み',
  fillOpacity: '塗りの不透明度',
  strokeOpacity: '線の不透明度',
  histogramBinCount: 'Binの数',
  columnGroup: '棒グラフ',
  barGroup: '棒グラフ',
  pieGroup: '円グラフ',
  lineGroup: '線グラフ',
  scatterGroup: 'XY（散布図）',
  areaGroup: '麺グラフ',
  histogramGroup: 'ヒストグラム',
  groupedColumnTooltip: 'グループ化されました',
  stackedColumnTooltip: '積まれています',
  normalizedColumnTooltip: '100%積まれています',
  groupedBarTooltip: 'グループ化されています',
  stackedBarTooltip: '積み重ねられました',
  normalizedBarTooltip: '100%積み上げられています',
  pieTooltip: '円グラフ',
  doughnutTooltip: '環状図',
  lineTooltip: '線図',
  groupedAreaTooltip: 'グループ化されました',
  stackedAreaTooltip: '積み上げられました',
  normalizedAreaTooltip: '100%積み上げられています',
  scatterTooltip: '散布図',
  bubbleTooltip: 'バブル図',
  histogramTooltip: 'ヒストグラム',
  noDataToChart: '描画するデータがありません。',
  pivotChartRequiresPivotMode: 'パースペクティブは、パースペクティブモードが有効になっていることを確認する必要があります。',
  chartSettingsToolbarTooltip: 'メニュー',
  chartLinkToolbarTooltip: 'グラフへのリンク',
  chartUnlinkToolbarTooltip: 'グラフとのリンクを解除します',
  chartDownloadToolbarTooltip: 'グラフのダウンロード',

  // ARIA
  ariaHidden: '非表示',
  araiaVisible: '可視',
  araiaChecked: 'チェック済み',
  ariaUnchecked: 'チェックされていません',
  ariaIndeterminate: '不確定',
  ariaColumnSelectAll: 'すべての列の選択を切り替え',
  ariaInputEditor: '入力エディタ',
  ariaDateFilterInput: '日付でフィルタ',
  ariaFilterInput: '入力フィルタ',
  ariaFilterColumnsInput: 'フィルタ列入力',
  ariaFilterValue: 'フィルタ値',
  ariaFilterFromValue: '--値からフィルタ',
  ariaFilterToValue: '-to-値でフィルタ',
  ariaFilteringOperator: 'フィルタ演算子',
  ariaColumnToggleVisibility: '列の表示/非表示を切り替え',
  ariaColumnGroupToggleVisibility: '列グループの可視性の切り替え',
  ariaRowSelect: 'スペースキーを押してこの行を選択します',
  ariaRowDeselect: 'スペースキーを押してこの行の選択を解除します',
  ariaRowToggleSelection: 'スペースキーで改行して選択',
  ariaRowSelectAll: 'スペースキーですべての行選択を切り替え',
  ariaSearch: '検索する',
  ariaSearchFilterValues: '検索フィルタ値'
}
